import { createContext, useContext } from 'react'
import NextPageService from '../services/nextpage.service'
import { UI, NextPagePropertiesModel } from '@cvx/nextpage-typescript'
import { NextPageOptionsModel } from '../models/nextpage-options.model'

export type NextpageContent = {
  UI: UI
  properties: NextPagePropertiesModel
  options: NextPageOptionsModel
}

export const NextpageContext = createContext<NextpageContent>(
  {} as NextPageService
)
export const useNextpageContext = () => useContext(NextpageContext)
